module.exports = __webpack_public_path__ + "media/carousel_images/Imagen4-768ed85b.png";